import { useState } from 'react';
import { Button, InlineAlert } from '@/contasis';
import { MAXIMO_IDEA_RETROALIMENTACION } from '../constantes';
import { useToast } from '@/contexts/ContextoToast';
import { CampoComentarioBreve } from './CampoComentarioBreve';
import { useEstadoEnvioLocal } from '../hooks/useEstadoEnvioLocal';
import { useRetroalimentacion } from '../hooks/useRetroalimentacion';
import { normalizarTextoBreve } from '../reglasFrecuencia';

export function BuzonIdeas() {
  const { enviarIdea, cerrarPanel } = useRetroalimentacion();
  const { showError } = useToast();
  const [contenido, setContenido] = useState('');
  const { enviado, enviando, ejecutarEnvioLocal, reiniciarEstadoEnvio } = useEstadoEnvioLocal();

  const contenidoNormalizado = normalizarTextoBreve(contenido);
  const puedeEnviar = contenidoNormalizado.length > 0 && !enviando;

  const actualizarContenido = (valor: string) => {
    setContenido(valor);

    if (enviado) {
      reiniciarEstadoEnvio();
    }
  };

  const enviar = async () => {
    const ok = await ejecutarEnvioLocal(() => enviarIdea({ contenido: contenidoNormalizado }));

    if (ok === 'omitido') {
      return;
    }

    if (ok === 'fallido') {
      showError('No pudimos guardar tu idea. Inténtalo de nuevo.');
      return;
    }

    setContenido('');
  };

  if (enviado) {
    return (
      <div className="space-y-5">
        <InlineAlert variant="success" title="Gracias por compartir tu idea" />

        <div className="flex flex-wrap justify-end gap-2">
          <Button variant="secondary" onClick={reiniciarEstadoEnvio}>
            Compartir otra idea
          </Button>
          <Button variant="primary" onClick={cerrarPanel}>
            Cerrar
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-5">
      <h3 className="text-ui-base font-semibold text-primary">Cuéntanos tu idea</h3>

      <CampoComentarioBreve
        etiqueta="Tu idea"
        valor={contenido}
        onChange={actualizarContenido}
        placeholder="Ejemplo: me ayudaría tener un resumen más claro al cerrar la caja del día."
        maximoCaracteres={MAXIMO_IDEA_RETROALIMENTACION}
        filas={5}
        disabled={enviando}
      />

      <div className="flex justify-end">
        <Button variant="primary" onClick={enviar} disabled={!puedeEnviar} loading={enviando} loadingText="Enviando...">
          Enviar idea
        </Button>
      </div>
    </div>
  );
}
